export default function CTADownload() {
  return (
    <section id="download" className="relative w-full min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20wide%20panoramic%20abstract%20composition%20with%20warm%20gradients%20from%20deep%20charcoal%20to%20rich%20coral%20and%20amber%20tones%20soft%20diffused%20ambient%20light%20with%20subtle%20geometric%20texture%20modern%20minimalist%20style%20cinematic%20atmosphere%20suitable%20for%20a%20background%20no%20text%20no%20people%20just%20atmospheric%20color%20gradients%20and%20subtle%20patterns&width=1600&height=700&seq=cta-download-bg&orientation=landscape"
          alt="下载51在线吃瓜APP"
          title="51在线吃瓜app下载"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-6">
            下载51在线吃瓜APP
          </h2>

          <div className="flex flex-col sm:flex-row items-start gap-6">
            <a
              href="#"
              className="px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-3"
            >
              <span>立即下载</span>
              <div className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-950">
                <i className="ri-arrow-right-line text-background-50 text-sm"></i>
              </div>
            </a>

            <div className="text-background-200 text-base leading-relaxed max-w-xs">
              随时随地吃瓜，不错过任何爆料
              <br />
              支持 iOS 与 Android 平台
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}